import { render, staticRenderFns } from "./KpiStaff.vue?vue&type=template&id=ad25637a&scoped=true"
import script from "./KpiStaff.vue?vue&type=script&lang=js"
export * from "./KpiStaff.vue?vue&type=script&lang=js"
import style0 from "./KpiStaff.vue?vue&type=style&index=0&id=ad25637a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad25637a",
  null
  
)

export default component.exports